<template>
  <div>
    <!-- <span class="glyphicon glyphicon-chevron-up"></span> -->
    <el-backtop class="top-box" :bottom="331" :right="36">
      <div class="el-top">
        <el-icon><ArrowUpBold /></el-icon>
      </div>
    </el-backtop>
  </div>
</template>
<script>
export default {
  name: "GoTop",
  data() {
    return {
      flag: false,
    };
  },
  methods: {},
};
</script>
<style scoped lang="less">
.el-top {
  height: 100%;
  width: 100%;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  background-color: rgb(71, 102, 255);
  border-radius: 6px;
  .el-icon{
    position: relative;
    top: 2px;
  }
}
@media (max-width: 997px) {
  .top-box {
    width: 30px;
    height: 30px;
    right: 8px !important;
    bottom: 235px !important;
    .el-top {
      line-height: 20px;
      .el-icon {
        width: 15px;
        position: relative;
    top: 5px;
      }
    }
  }
}
</style>
